import React from 'react';
import photoC from './../../../assets/img/brand/eduPlus2026.png';
import bar from './../../../assets/img/brand/luxmed/barImg.png';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import ProductCta from '../../../components/ProductCta/ProductCta';
import { ProgramTable, BUY_LINK } from './ProgramTable';

const Dziecko = (props) => {
  return (
    <React.Fragment>
      <h2 className="page-header mt-4">EDU Plus - Dziecko</h2>
      <img src={bar} alt={bar} />
      <br />
      <br />
      <div className="container">
        <div class="row">
          <div class="col-md-6">
            <div style={{ padding: '10px' }}> </div>

            <p
              className="gradient-text"
              style={{ fontSize: '1.5rem', fontWeight: 'bolder' }}>
              Jedna polisa na milion pomysłów
            </p>
            <p style={{ fontSize: '1.2rem' }}>
              Program ochrony ubezpieczeniowej na rok <b>2026/2027</b>
            </p>
            <br />
            <ul>
              <li>
                <b>Ochrona 365 dni przez 24 h na dobę –</b> ochrona
                ubezpieczeniowa w ciągu całego roku szkolnego i wakacji na
                terenie całego świata.
              </li>
              <li>
                <b>Kumulacja</b> – wypłaty świadczeń z opcji głównej i opcji
                dodatkowych sumują się.
              </li>
              <li>
                <b style={{ color: '#ff0000' }}>
                  Wyższe świadczenie w przypadku uszczerbku w wyniku NW powyżej
                  25%
                </b>
              </li>
              <li>
                <b style={{ color: '#ff0000' }}>SPORT</b> – rekreacyjne i
                wyczynowe uprawianie sportu w zakresie, również za
                wynagrodzeniem.
              </li>
              <li>Pokrycie udokumentowanych kosztów <b>porady psychologa</b>.</li>
              <li>
                <b>Pakiet Kleszcz</b> – pokrycie kosztów badań diagnostycznych,
                antybiotykoterapii, usunięcia kleszcza oraz wypłata świadczenia
                za rozpoznanie boreliozy.
              </li>
              <li>
                <b>Hejt Stop</b> – wsparcie psychologiczne, prawne i
                informatyczne, w zakresie mowy nienawiści i bezpieczeństwa w
                sieci.
              </li>
              <li>
                <b>Koszty podróży marzeń</b> – sfinansowanie realizacji
                marzenia dziecka z orzeczeniem o niepełnosprawności.
              </li>
              <li>
                <b>Koszty akcji poszukiwawczej dziecka</b> – pokrycie
                poniesionych kosztów przez rodzica lub opiekuna prawnego w
                związku z zaginięciem dziecka.
              </li>
              <li>
                Infolinia czynna 24h / 7 dni w tygodniu <b>22 575 25 25</b>.
                Szybki, prosty i nowoczesny sposób zgłoszenia szkody on-line na
                stronie www.interrisk.pl. Uproszczona procedura wypłaty
                odszkodowania.
              </li>
            </ul>

            <br />
            <div
              style={{
                padding: '18px',
                borderRadius: '18px',
                border: '1px solid rgba(0, 60, 125, 0.14)',
                background:
                  'linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(240,246,255,1) 100%)',
                boxShadow: '0 18px 36px rgba(0, 60, 125, 0.08)'
              }}>
              <div
                style={{
                  color: '#003c7d',
                  fontSize: '0.8rem',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  marginBottom: '8px'
                }}>
                Kup online
              </div>
              <h5 style={{ marginBottom: '8px', fontWeight: 700 }}>
                Zadbaj o ochronę dziecka już teraz
              </h5>
              <p style={{ marginBottom: '14px', lineHeight: 1.5 }}>
                Wybierz wariant, oblicz składkę i kup polisę online w kilka
                minut.
              </p>

              <ProductCta href={BUY_LINK} icon={faShoppingCart}>
                Kup ubezpieczenie NNW dla dziecka
              </ProductCta>
            </div>
          </div>

          <div class="col-md-6">
            <img src={photoC} alt="firstPhoto" style={{ width: 'inherit' }} />
          </div>
          <br />
          <br />
        </div>
      </div>
      <br />
      <br />
      <div class="container">
        <h3>WYBIERZ PROGRAM OCHRONY UBEZPIECZENIOWEJ NA ROK 2026/2027</h3>

        <ProgramTable />
      </div>
    </React.Fragment>
  );
};

export default Dziecko;
